import { IApiService } from '../../interfaces/api-service';
import { IAppConfigService } from '../../interfaces/app-config-service';

export abstract class ApiServiceBase {
	private apiService: IApiService;
	private appConfigService: IAppConfigService;

	constructor(apiService: IApiService, appConfigService: IAppConfigService) {
		this.apiService = apiService;
		this.appConfigService = appConfigService;
	}

	protected GetFromApi<T>(endpointUri: string): Promise<T> {
		const baseUri =
			process.env.NODE_ENV === 'production'
				? this.appConfigService.cxDataApiUrl
				: this.appConfigService.cxDataLocalApiUrl;

		return this.apiService.Get<T>(baseUri, endpointUri);
	}

	protected PostToApi<T>(endpointUri: string, payload: any = {}, responseType: 'json' | 'blob' = 'json'): Promise<T> {
		const baseUri =
			process.env.NODE_ENV === 'production'
				? this.appConfigService.cxDataApiUrl
				: this.appConfigService.cxDataLocalApiUrl;

		return this.apiService.Post<T>(baseUri, endpointUri, payload, responseType);
	}

	protected PostStreamToApi(
		endpointUri: string, 
		payload: any, 
		onChunk: (chunk: string) => void, 
		onError?: (error: Error) => void, 
		onComplete?: () => void
	): Promise<void> {
		const baseUri =
			process.env.NODE_ENV === 'production'
				? this.appConfigService.cxDataApiUrl
				: this.appConfigService.cxDataLocalApiUrl;

		return this.apiService.PostStream(baseUri, endpointUri, payload, onChunk, onError, onComplete);
	}

	protected PutToApi<T>(endpointUri: string, payload: any = {}): Promise<T> {
		const baseUri =
			process.env.NODE_ENV === 'production'
				? this.appConfigService.cxDataApiUrl
				: this.appConfigService.cxDataLocalApiUrl;

		return this.apiService.Put<T>(baseUri, endpointUri, payload);
	}

	protected DeleteFromApi<T>(endpointUri: string): Promise<T> {
		const baseUri =
			process.env.NODE_ENV === 'production'
				? this.appConfigService.cxDataApiUrl
				: this.appConfigService.cxDataLocalApiUrl;

		return this.apiService.Delete<T>(baseUri, endpointUri);
	}
}
